var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.3,11.7l1.4,0.4H31c0.2-0.4-0.1-0.7-0.7-1.3c-1.4-1.3-3.1-2.2-5-2.5h-7v0.3c0,0.3-0.2,0.5-0.5,0.5 c-0.3,0-0.5-0.2-0.5-0.5V8.3c0-0.4-0.4-0.8-0.8-0.8h-1.8c-0.4,0-0.8,0.4-0.8,0.8v3.8c0,0.4,0.4,0.8,0.8,0.8h1.8 c0.4,0,0.8-0.4,0.8-0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v0.3h2.1v6.4c-0.4,0.1-0.8,0.4-0.8,0.8v17 c0,0.5,0.4,0.9,0.9,0.9h2.7c0.5-0.1,0.8-0.4,0.8-0.9V19.5c0-0.4-0.4-0.7-0.8-0.8v-6.4h2.1v-1.5C26.7,10.9,28,11.2,29.3,11.7z  M16.8,12.1L16.8,12.1c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3v0V8.3c0-0.2,0.1-0.3,0.3-0.3h1.8c0.2,0,0.3,0.1,0.3,0.3 V12.1z M18.3,11.1L17.8,11h-0.5V9.4l0.5,0.2l0.5-0.2V11.1z M23.4,19.5v17.1c0,0.2-0.1,0.3-0.3,0.3h-2.7c-0.2,0-0.3-0.1-0.3-0.3v0 V19.5c0-0.2,0.1-0.3,0.3-0.3h0.1h2.6C23.3,19.2,23.4,19.3,23.4,19.5z M24.8,11.8h-1.6h-2.8h-1.6v-3h6V11.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "17.3,9.4 17.3,11 17.8,11 18.3,11.1 18.3,9.4 17.8,9.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9444",
    d: "M23.1,19.2h-2.6h-0.1c-0.2,0-0.3,0.1-0.3,0.3v17.1v0c0,0.2,0.1,0.3,0.3,0.3h2.7c0.2,0,0.3-0.1,0.3-0.3V19.5 C23.4,19.3,23.3,19.2,23.1,19.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A1A1A1",
    points: "18.8,8.8 18.8,11.8 20.4,11.8 23.2,11.8 24.8,11.8 24.8,8.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.5,8h-1.8c-0.2,0-0.3,0.1-0.3,0.3v3.8v0c0,0.2,0.1,0.3,0.3,0.3h1.8c0.2,0,0.3-0.1,0.3-0.3v0V8.3 C16.8,8.1,16.7,8,16.5,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairs);
export default __webpack_public_path__ + "static/media/repairs.cfc0a1ffaccee75b2d78fa3c497a48c5.svg";
export { ForwardRef as ReactComponent };